import { ApiClient } from "../../ApiClient"
import { GetIndustriesResponse, GetIndustryFamiliesResponse } from "../schema/GetIndustriesResponse";
import { Industry } from "@/@types"
import { mapIndustrie } from "../../mappers/industrieMapper";

export const getIndustry = async (): Promise<Industry[]> => {

  const client = ApiClient.getInstance()
  const response = await client.get<GetIndustriesResponse>("industries")

  const industries = response.data.map(mapIndustrie)

  // Sort industries by order
  return industries.sort((a, b) => (a.order ?? 0) - (b.order ?? 0))

}

export const getIndustryBySlugAndFamilies = async (slug: string): Promise<GetIndustryFamiliesResponse> => {

  const client = ApiClient.getInstance()
  const response = await client.get<GetIndustryFamiliesResponse>(`products/industries/${slug}/families`)

  return response;

}